/* eslint-disable max-len */
import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import location from '../../../public/assets/location-20.png';
import language from '../../../public/assets/language-20.png';
import session from '../../../public/assets/session-20.png';
import calender from '../../../public/assets/calendar-20.png';
import CourseCTA from './course-cta-button';

const typeClasses = {
  Online: 'bg-[#dff4cf] text-[#264909]',
  Regular: 'bg-[#E3EAFF] text-[#002FFF]',
  Weekend: 'bg-[#ffeecc] text-[#AA6311]',
};

function CourseDetailsInfo({
  courseDetail,
  //   isExpanded,
  //   toggleText,
  btnText = '',
  btnDesktopClass = '',
  btnMobileClass = '',
  handleClick,
  // setShowBatchPopup,
  Amount,
  batchListedPrice,
  batchName,
  productStatus,
  batchPrice,
  bacthCtaCLick,
  isScrolledPast,
  handleRequestCall,
}) {
  return (
    <div className={`flex flex-col lg:flex-row ${isScrolledPast ? '' : 'gap-5'}`}>
      <div className={`w-full transition-all duration-300 ease-in-out overflow-hidden ${isScrolledPast ? 'lg:absolute lg:w-0 lg:top-0 lg:bottom-0' : 'lg:relative lg:w-[30%]'}`}>
        <div className="relative w-full h-full">
          <span className={`inline-flex absolute  items-center  text-xs font-light rounded right-1.5 top-1.5  p-paddingTag ${typeClasses[courseDetail?.type]}`}>{courseDetail?.type}</span>
          <Image width={628} height={319} src={courseDetail?.cardImage} alt="courseBanner" className="rounded-md h-full aspect-[628/319] " />
        </div>
      </div>
      <div className={`w-full transition-all duration-700 ease-in-out ${isScrolledPast ? 'lg:w-full lg:-ml-0' : 'lg:w-[70%]'}`}>
        <div className="flex justify-between mb-3 lg:mb-[10px] items-center">
          <span className="inline-flex items-center text-xs font-medium rounded p-paddingTag bg-lightSky text-lightSky">{courseDetail?.exam?.name}</span>
          {(btnText === 'Download Brochure' ? courseDetail?.brochure : true) && (
            <div className="">
              <button
                onClick={handleClick}
                type="button"
                className={`${btnDesktopClass}`}
              >
                {btnText === 'Download Brochure'
                  && (
                    <span className="pe-2">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.88736 9.65737C6.90072 9.67444 6.9178 9.68825 6.93729 9.69775C6.95678 9.70724 6.97818 9.71218 6.99986 9.71218C7.02154 9.71218 7.04294 9.70724 7.06243 9.69775C7.08192 9.68825 7.099 9.67444 7.11236 9.65737L9.11236 7.12701C9.18557 7.03415 9.1195 6.89665 8.99986 6.89665H7.67665V0.853795C7.67665 0.775223 7.61236 0.710938 7.53379 0.710938H6.46236C6.38379 0.710938 6.3195 0.775223 6.3195 0.853795V6.89487H4.99986C4.88022 6.89487 4.81415 7.03237 4.88736 7.12522L6.88736 9.65737ZM13.5356 9.03237H12.4641C12.3856 9.03237 12.3213 9.09665 12.3213 9.17522V11.9252H1.67843V9.17522C1.67843 9.09665 1.61415 9.03237 1.53557 9.03237H0.464146C0.385575 9.03237 0.321289 9.09665 0.321289 9.17522V12.7109C0.321289 13.027 0.576646 13.2824 0.892718 13.2824H13.107C13.4231 13.2824 13.6784 13.027 13.6784 12.7109V9.17522C13.6784 9.09665 13.6141 9.03237 13.5356 9.03237Z" fill="black" />
                      </svg>
                      {/* <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M0.0834961 10.5C0.0834961 5.58951 0.083496 3.13428 1.60899 1.6088C3.13446 0.0833129 5.58969 0.083313 10.5002 0.083313C15.4106 0.083313 17.8659 0.0833129 19.3913 1.6088C20.9168 3.13428 20.9168 5.58951 20.9168 10.5C20.9168 15.4104 20.9168 17.8657 19.3913 19.3911C17.8659 20.9166 15.4106 20.9166 10.5002 20.9166C5.58969 20.9166 3.13446 20.9166 1.60899 19.3911C0.083496 17.8657 0.0834961 15.4104 0.0834961 10.5ZM10.5002 4.5104C10.9316 4.5104 11.2814 4.86018 11.2814 5.29165V10.6972L13.0728 8.90592C13.3779 8.60081 13.8725 8.60081 14.1776 8.90592C14.4827 9.21102 14.4827 9.70561 14.1776 10.0107L11.0526 13.1357C10.9061 13.2823 10.7074 13.3646 10.5002 13.3646C10.293 13.3646 10.0942 13.2823 9.94777 13.1357L6.82274 10.0107C6.51764 9.70561 6.51764 9.21102 6.82274 8.90592C7.12783 8.60081 7.6225 8.60081 7.92759 8.90592L9.71891 10.6972V5.29165C9.71891 4.86018 10.0687 4.5104 10.5002 4.5104ZM6.3335 14.9271C5.90203 14.9271 5.55225 15.2769 5.55225 15.7083C5.55225 16.1398 5.90203 16.4896 6.3335 16.4896H14.6668C15.0983 16.4896 15.4481 16.1398 15.4481 15.7083C15.4481 15.2769 15.0983 14.9271 14.6668 14.9271H6.3335Z" fill="#0267B1" />
                </svg> */}
                    </span>
                  )}
                {btnText}

              </button>

            </div>
          )}
        </div>
        <div className={`${isScrolledPast ? '' : 'lg:mb-4'}`}>
          <h3 className={`lg:font-semibold font-medium text-black line-clamp-2 ${isScrolledPast ? '' : 'lg:mb-5 mb-4'} text-lg`}>
            {courseDetail?.name}
          </h3>
          <div className={`w-full lg:w-[45%] overflow-hidden ${isScrolledPast ? 'hidden' : ''} `}>
            <ul className="grid grid-cols-2 flex-wrap lg:gap-y-3.5 gap-3 lg:text-sm text-xs text-black">
              <li className="flex items-center pe-3 whitespace-nowrap">
                <Image className="lg:w-5 lg:h-5 w-4 h-4" width={20} height={20} src={calender} alt={courseDetail?.duration} />
                <span className="pl-2">
                  <span className="font-medium"> Duration:</span>
                  {' '}
                  <span className="font-light">
                    {courseDetail?.duration}
                    {' '}
                    {courseDetail?.durationType}
                    {`${courseDetail?.duration > 1 ? 's' : ''}`}
                  </span>
                </span>
              </li>
              <li className="flex items-center whitespace-nowrap">
                <Image width={20} height={20} className="lg:w-5 lg:h-5 w-4 h-4" src={language} alt={courseDetail?.courseLanguage} />
                <span className="pl-2">
                  <span className="font-medium"> Language:</span>
                  {' '}
                  <span className="font-light">
                    {' '}
                    {courseDetail?.courseLanguage}
                    {' '}
                  </span>
                </span>
              </li>
              <li className="flex items-center whitespace-nowrap">
                <Image width={20} height={20} className="lg:w-5 lg:h-5 w-4 h-4" src={session} alt={courseDetail?.session?.name} />
                <span className="pl-2">
                  <span className="font-medium"> Session: </span>
                  <span className="font-light">
                    {' '}
                    {courseDetail?.session?.name}
                    {' '}
                  </span>
                </span>
              </li>
              {courseDetail?.type !== 'Online'
                && (
                  <li className="flex items-center whitespace-nowrap">
                    <Image width={20} height={20} className="lg:w-5 lg:h-5 w-4 h-4" src={location} alt={courseDetail?.centre?.name} />
                    <span className="pl-2">
                      <span className="lg:font-semibold">Center: </span>
                      {' '}
                      <span className="font-light">
                        {' '}
                        {courseDetail?.centre?.name}
                        {' '}
                      </span>
                    </span>
                  </li>
                )}
            </ul>
          </div>
        </div>
        {/* preprartion button */}
        <div className={`${isScrolledPast ? 'hidden' : 'lg:block'}  mt-6 relative w-full before:absolute before:top-0 before:content-[''] before:w-full before:h-[1px] before:bg-[#D9D9D9] hidden`}>
          <CourseCTA handleClick={bacthCtaCLick} handleRequestCall={handleRequestCall} cusWidth="max-w-[218px]" otherCss="rounded-0" cusPadding="lg:pt-3 lg:pb-0" Amount={Amount || batchListedPrice?.listedCost} batchName={batchName} productStatus={productStatus} batchPrice={batchPrice} />
        </div>
        {/* <div className="lg:flex justify-between pt-5 relative before:absolute before:top-0 before:content-[''] before:w-full before:h-[1px] before:bg-[#D9D9D9] hidden">
          <div className="">
            <p className="text-base font-semibold text-black">{Amount}</p>
            <small className="font-normal text-xs">Installment Options Available</small>
          </div>
          <button type="button" onClick={() => setShowBatchPopup(true)} className="bg-[#1562AF] py-2 px-[51px] relative group overflow-hidden text-white text-base font-semibold ">
            Start Your Prep
            <div className="absolute bg-[linear-gradient(180deg,rgb(85_155_228_/0%)_0%,rgb(162_199_239_/20%)_50%,rgba(22,98,177,0)_100%)] inset-0 opacity-0 group-hover:opacity-100 animate-rain pointer-events-none" />
          </button>
        </div> */}
        {/* for mobile */}
        {(btnText === 'Download Brochure' ? courseDetail?.brochure : true) && (
          <button
            onClick={handleClick}
            type="button"
            className={btnMobileClass}
          >
            {
              btnText === 'Download Brochure'
              && (
                <span className="pe-2">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0.0834961 10.5C0.0834961 5.58951 0.083496 3.13428 1.60899 1.6088C3.13446 0.0833129 5.58969 0.083313 10.5002 0.083313C15.4106 0.083313 17.8659 0.0833129 19.3913 1.6088C20.9168 3.13428 20.9168 5.58951 20.9168 10.5C20.9168 15.4104 20.9168 17.8657 19.3913 19.3911C17.8659 20.9166 15.4106 20.9166 10.5002 20.9166C5.58969 20.9166 3.13446 20.9166 1.60899 19.3911C0.083496 17.8657 0.0834961 15.4104 0.0834961 10.5ZM10.5002 4.5104C10.9316 4.5104 11.2814 4.86018 11.2814 5.29165V10.6972L13.0728 8.90592C13.3779 8.60081 13.8725 8.60081 14.1776 8.90592C14.4827 9.21102 14.4827 9.70561 14.1776 10.0107L11.0526 13.1357C10.9061 13.2823 10.7074 13.3646 10.5002 13.3646C10.293 13.3646 10.0942 13.2823 9.94777 13.1357L6.82274 10.0107C6.51764 9.70561 6.51764 9.21102 6.82274 8.90592C7.12783 8.60081 7.6225 8.60081 7.92759 8.90592L9.71891 10.6972V5.29165C9.71891 4.86018 10.0687 4.5104 10.5002 4.5104ZM6.3335 14.9271C5.90203 14.9271 5.55225 15.2769 5.55225 15.7083C5.55225 16.1398 5.90203 16.4896 6.3335 16.4896H14.6668C15.0983 16.4896 15.4481 16.1398 15.4481 15.7083C15.4481 15.2769 15.0983 14.9271 14.6668 14.9271H6.3335Z" fill="#0267B1" />
                  </svg>
                </span>
              )
            }
            {btnText}
          </button>
        )}
      </div>
    </div>
  );
}

CourseDetailsInfo.propTypes = {
  courseDetail: PropTypes.shape({
    type: PropTypes.string,
    cardImage: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object, // for imported images
    ]),
    exam: PropTypes.shape({
      name: PropTypes.string,
    }),
    name: PropTypes.string,
    description: PropTypes.string,
    duration: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    durationType: PropTypes.string,
    session: PropTypes.shape({
      name: PropTypes.string,
    }),
    language: PropTypes.string,
    courseLanguage: PropTypes.string,
    centre: PropTypes.shape({
      name: PropTypes.string,
    }),
    brochure: PropTypes.any,
  }).isRequired,
  btnText: PropTypes.string,
  btnDesktopClass: PropTypes.string,
  btnMobileClass: PropTypes.string,
  handleClick: PropTypes.func,
  Amount: PropTypes.any,
  batchListedPrice: PropTypes.any,
  batchName: PropTypes.any,
  productStatus: PropTypes.any,
  batchPrice: PropTypes.any,
  bacthCtaCLick: PropTypes.any,
  isScrolledPast: PropTypes.any,
  handleRequestCall: PropTypes.any,
};

export default CourseDetailsInfo;
